module.exports = __webpack_public_path__ + "static/media/eye-solid.9031ec88.svg";